import { render } from "./SubareaDatatable.vue?vue&type=template&id=46e15a71"
import script from "./SubareaDatatable.vue?vue&type=script&lang=js"
export * from "./SubareaDatatable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__